// The phone's small helpers (Stage 4.8f.4a): a duration, a live "seconds since", the colour of how a colleague is now.
import { useEffect, useState } from "react";

export const fmtDur = (s) => {
  const n = Math.max(0, Math.round(Number(s) || 0));
  const h = Math.floor(n / 3600), m = Math.floor((n % 3600) / 60), sec = n % 60;
  return h ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}` : `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};

// Seconds since `since` (ms), ticking each second.
export function useSince(since) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!since) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [since]);
  return since ? Math.max(0, Math.round((now - since) / 1000)) : 0;
}

export const PRESENCE_COLOR = {
  available: "var(--success)", on_call: "var(--danger)", ringing: "var(--warning)", break: "var(--warning)",
  dnd: "var(--danger)", offline: "var(--ink-400)", unknown: "var(--ink-400)",
};
